const isValidNumber = (number) => {
  const regex = /^[0-9.]+$/;
  if (number === "" || regex.test(number)) {
    return true;
  }
  return false;
};

export default isValidNumber;
